import { render, staticRenderFns } from "./BankPage.vue?vue&type=template&id=dfd11586&"
import script from "./BankPage.vue?vue&type=script&lang=js&"
export * from "./BankPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports